import React, { Component } from 'react';
import { trans } from '../../../helpers';
import ApiManager from '../../../apiManager';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';
import Modal from '../../Fragments/Modal';

class B2bMyAccount extends Component {

    constructor( props ){
        super( props );

        this.state = {
            // Profile state
            fullName: '...',
            email: '...',
            contactNumber: '...',
            // Form state
            editFormFirstName: '',
            editFormLastName: '',
            editFormEmail: '',
            editFormContactNumber: '',
            editFormOldPassword: '',
            editFormNewPassword: '',
            editFormConfirmPassword: '',
            editFormButtonDisabled: false,
            editFormResponse: '',
            editDataSuccessModalShow: false,
            // Toggle form state
            editView: false
        };

        // Component props
        this.componentIsMounted = true;

        // Bind own methods
        this.editDataSuccess = this.editDataSuccess.bind( this );

    }

    componentWillUnmount() {

        this.componentIsMounted = false

    }

    componentDidMount() {

        if ( this.props.profileData !== '' && this.props.profileData.status === 'OK' ) {

            const newState = {
                fullName: this.props.profileData.data.first_name + ' ' + this.props.profileData.data.last_name,
                email: this.props.profileData.data.email,
                editFormFirstName: this.props.profileData.data.first_name,
                editFormLastName: this.props.profileData.data.last_name,
                editFormEmail: this.props.profileData.data.email
            };

            if ( this.props.profileData.data.hasOwnProperty('contact_number') && this.props.profileData.data.contact_number !== '' ) {
                newState['contactNumber'] = this.props.profileData.data.contact_number;
                newState['editFormContactNumber'] = this.props.profileData.data.contact_number;
            }

            this.setState( newState );

        }

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {

        if ( nextProps.profileData !== '' && nextProps.profileData.status === 'OK' ) {

            nextState.fullName = nextProps.profileData.data.first_name + ' ' + nextProps.profileData.data.last_name;
            nextState.email = nextProps.profileData.data.email;

            if ( nextProps.profileData.data.hasOwnProperty('contact_number') && nextProps.profileData.data.contact_number !== '' ) {
                nextState.contactNumber = nextProps.profileData.data.contact_number;
            }

        }

        return nextState;

    }

    editDataSuccessModal(){

        if ( !this.state.editDataSuccessModalShow ) {
            return '';
        }

        return (
            <Modal
                title={trans(this.props.b2bTrans, 'b2b.profile.success_modal.title')}
                description={this.state.editFormResponse.hasOwnProperty('message') && this.state.editFormResponse.message}
                agreeText={trans(this.props.b2bTrans, 'b2b.profile.success_modal.agree')}
                agreeAction={() => {
                    this.setState({
                        editDataSuccessModalShow: false,
                        editView: false,


                        fullName: '...',
                        email: '...',
                        contactNumber: '...'
                    });
                    this.props.getProfile();
                }}
                className="modal--full"
            />
        );

    }

    editDataSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = {status: "OK", message: "Your profile has been successfully saved"};

        this.setState({
            editFormResponse: resolve.data,
            editFormButtonDisabled: false,
            editDataSuccessModalShow: resolve.data.status === 'OK'
        });

    }

    editData(){

        this.setState({
            editFormButtonDisabled: true
        });

        ApiManager.postRequest({
            jwt: this.props.getDecryptedToken(),
            _token: this.props.csrf_token.data,
            first_name: this.state.editFormFirstName,
            last_name: this.state.editFormLastName,
            contact_number: this.state.editFormContactNumber,
            password: this.state.editFormNewPassword,
            old_password: this.state.editFormOldPassword,
            password_confirmation: this.state.editFormConfirmPassword
        }, '/b2b/profile/update').then( this.editDataSuccess, this.props.errorCallBack );

    }

    editForm(){

        let firstNameErrorClass = '',
            firstNameErrorBox = '',
            lastNameErrorClass = '',
            lastNameErrorBox = '',
            numberErrorClass = '',
            numberErrorBox = '',
            errorBox = '';

        if ( this.state.editFormResponse !== '' ) {

            if ( this.state.editFormResponse.status === 'INVALID_DATA' ) {

                if ( this.state.editFormResponse.errors.hasOwnProperty('first_name') ) {
                    firstNameErrorClass = ' form-error';
                    firstNameErrorBox = <div className="form-error-text fs11">{this.state.editFormResponse.errors.first_name}</div>;
                }

                if ( this.state.editFormResponse.errors.hasOwnProperty('last_name') ) {
                    lastNameErrorClass = ' form-error';
                    lastNameErrorBox = <div className="form-error-text fs11">{this.state.editFormResponse.errors.last_name}</div>;
                }

                if ( this.state.editFormResponse.errors.hasOwnProperty('password') ) {
                    errorBox = <FormMiddlewareError message={this.state.editFormResponse.errors.password} />;
                }

                if ( this.state.editFormResponse.errors.hasOwnProperty('contact_number') ) {
                    numberErrorClass = ' form-error';
                    numberErrorBox = <div className="form-error-text fs11">{this.state.editFormResponse.errors.contact_number}</div>;
                }

            }

            if ( this.state.editFormResponse.status === 'ERROR' || this.state.editFormResponse.status === 'NOT_FOUND' ) {

                errorBox = <FormMiddlewareError message={this.state.editFormResponse.message} />;

            }

        }

        return (
            <form action="#" className="form form--profile ver-top-box" autoComplete="off" onSubmit={( event ) => {
                event.preventDefault();
                this.editData();
            }}>
                <h2 className="form__title fb fs20 pr">{trans( this.props.b2bTrans, 'b2b.profile.title' )}</h2>

                <div className={`form__form-box clear-fix${firstNameErrorClass}`}>

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="first-name">{trans( this.props.b2bTrans, 'b2b.profile.first_name' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="full-name"
                                type="text"
                                name="last-name"
                                value={this.state.editFormFirstName}
                                onChange={( event ) => this.setState({ editFormFirstName: event.target.value.trim() })}
                            />
                        </div>
                        {firstNameErrorBox}
                    </div>

                </div>

                <div className={`form__form-box clear-fix${lastNameErrorClass}`}>

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="last-name">{trans( this.props.b2bTrans, 'b2b.profile.last_name' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="last-name"
                                type="text"
                                name="last-name"
                                value={this.state.editFormLastName}
                                onChange={( event ) => this.setState({ editFormLastName: event.target.value.trim() })}
                            />
                        </div>
                        {lastNameErrorBox}
                    </div>

                </div>

                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="email">{trans( this.props.b2bTrans, 'b2b.profile.email' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <p className="form__form-value form__form-value--disabled select-none">{this.state.editFormEmail}</p>
                    </div>

                </div>

                <div className={`form__form-box clear-fix${numberErrorClass}`}>

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="contact-number">{trans( this.props.b2bTrans, 'b2b.profile.contact_number' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="contact-number"
                                type="text"
                                name="contact-number"
                                value={this.state.editFormContactNumber}
                                placeholder={trans( this.props.b2bTrans, 'b2b.profile.contact_number_placeholder' )}
                                onChange={( event ) => this.setState({ editFormContactNumber: event.target.value.trim().replace(/[^\d]/g, '') })}
                            />
                        </div>
                        {numberErrorBox}
                    </div>

                </div>

                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="old-password">{trans( this.props.b2bTrans, 'b2b.profile.old_password' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="old-password"
                                type="password"
                                name="old-password"
                                value={this.state.editFormOldPassword}
                                onChange={( event ) => this.setState({ editFormOldPassword: event.target.value.trim() })}
                            />
                        </div>
                        <div className="form-error-text dn fs13">Error text</div>
                    </div>

                </div>

                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="new-password">{trans( this.props.b2bTrans, 'b2b.profile.new_password' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="new-password"
                                type="password"
                                name="new-password"
                                value={this.state.editFormNewPassword}
                                onChange={( event ) => this.setState({ editFormNewPassword: event.target.value.trim() })}
                            />
                        </div>
                        <div className="form-error-text dn fs13">Error text</div>
                    </div>

                </div>

                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="confirm-new-password">{trans( this.props.b2bTrans, 'b2b.profile.confirm_new_password' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="confirm-new-password"
                                type="password"
                                name="confirm-new-password"
                                value={this.state.editFormConfirmPassword}
                                onChange={( event ) => this.setState({ editFormConfirmPassword: event.target.value.trim() })}
                            />
                        </div>
                        <div className="form-error-text dn fs13">Error text</div>
                    </div>

                </div>

                {errorBox}

                <div className="form__form-box">

                    <div className="form__form-right-box clear-fix tr pl-none">

                        <button
                            className={`btn btn--yellow fs17 ver-top-box${this.state.editFormButtonDisabled ? ' btn--loading' : ''}`}
                            disabled={this.state.editFormButtonDisabled}
                            type="submit"
                        >{trans( this.props.b2bTrans, 'b2b.profile.save_btn' )}</button>
                        <button
                            className="btn btn--white fs17 ver-top-box"
                            type="button"
                            onClick={() => this.setState({ editView: false })}
                        >{trans( this.props.b2bTrans, 'b2b.profile.cancel_btn' )}</button>

                    </div>

                </div>

            </form>
        );

    }

    view(){

        let contactNumber = '';

        if ( this.state.contactNumber !== '...' ) {
            contactNumber = (
                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label db fs11" htmlFor="contact-number">{trans( this.props.b2bTrans, 'b2b.profile.contact_number' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <p className="form__form-value">{this.state.contactNumber}</p>
                    </div>

                </div>
            );
        }

        return (
            <form action="#" className="form form--profile ver-top-box">
                <h2 className="form__title fb fs20 pr">
                    {trans( this.props.b2bTrans, 'b2b.profile.title' )}
                    {
                        this.props.curator !== 'curator' ?
                            <button
                                className="form__edit sprite pa"
                                type="button"
                                title={trans( this.props.b2bTrans, 'b2b.profile.edit.btn.title' )}
                                onClick={() => {

                                    const newState = {
                                        editView: true
                                    };

                                    if ( this.props.profileData !== '' && this.props.profileData.status === 'OK' ) {

                                        newState['editFormFirstName'] = this.props.profileData.data.first_name;
                                        newState['editFormLastName'] = this.props.profileData.data.last_name;
                                        newState['editFormEmail'] = this.props.profileData.data.email;

                                        if ( this.props.profileData.data.hasOwnProperty('contact_number') && this.props.profileData.data.contact_number !== '' ) {
                                            newState['editFormContactNumber'] = this.props.profileData.data.contact_number;
                                        }

                                    }

                                    this.setState( newState );

                                }}
                            >&nbsp;</button>
                            : ''
                    }
                </h2>

                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label db fs11" htmlFor="full-name">{trans( this.props.b2bTrans, 'b2b.profile.full_name' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <p className="form__form-value">{this.state.fullName}</p>
                    </div>

                </div>

                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label form__form-label--pt15 db fs11" htmlFor="email">{trans( this.props.b2bTrans, 'b2b.profile.email' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <p className="form__form-value form__form-value--disabled select-none">{this.state.email}</p>
                    </div>

                </div>
                {contactNumber}
                <div className="form__form-box clear-fix">

                    <div className="form__form-label-box fl">
                        <label className="form__form-label db fs11" htmlFor="password">{trans( this.props.b2bTrans, 'b2b.profile.password' )}</label>
                    </div>

                    <div className="form__form-right-box">
                        <p className="form__form-value">
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                            <span className="form__form-dot ver-middle-box">&nbsp;</span>
                        </p>
                    </div>

                </div>

            </form>
        );

    }

    render(){

        return(
            <div className="main-wrapper__right-inner scroller-block pr">
                <div className="main-wrapper__right-content">{
                    this.state.editView ?
                        this.editForm() :
                        this.view()
                }</div>
                {this.editDataSuccessModal()}
            </div>
        );

    }

}

export default B2bMyAccount;